import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import CampaignSlider from '../../components/CampaignSlider'

import home_bgs from '../../assets/prof_bann.png'
import partners_bg from '../../assets/ww.png'

import netflix from '../../assets/netflix.png'
import showtime from '../../assets/showtime.png'
import mnet_movies from '../../assets/mnet-movies.png'
import fox from '../../assets/fox.png'
import disney_small from '../../assets/disney_small.png'

import project1 from '../../assets/project1.png'

import check_circle from '../../assets/check-circle.png'

import ProfessionalBox from '../../components/general/homepage/ProfessionalBox'
import man_camera from '../../assets/man_camera.png'
import amaka from '../../assets/amaka.png'
import peter from '../../assets/peter.png'
import sophia from '../../assets/sophia.png'
import noah from '../../assets/noah.png'
import bozzy from '../../assets/bozzy.png'

import man_watch from '../../assets/man_watch.png'

const Professionals = () => {
	const [selected, setSelected] = useState('')

	let tags = ['cinematographer', 'Producer', 'Director', 'Photographer']

	let profss = [
		{
			image: project1,
			title: 'Actors',
		},
		{
			image: bozzy,
			title: 'Producers',
		},
		{
			image: project1,
			title: 'Make up artist',
		},
		{
			image: project1,
			title: 'Cinematographers',
		},
	]

	let settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		autoplay: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	}

	let partnersSettings = {
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	}

	let tips = [
		{
			icon: check_circle,
			title: 'The best crew for every budget',
			para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
		},
		{
			icon: check_circle,
			title: 'Quality work done quickly',
			para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
		},
		{
			icon: check_circle,
			title: 'Protected investment funds',
			para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
		},
		{
			icon: check_circle,
			title: 'Best production equipments in the industry',
			para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
		},
	]

	const profs = [
		{
			id: 1,
			image: amaka,
			name: 'Amaka Cross',
			role: 'Photographer/Cinematographer',
			no_of_projects: 105,
		},
		{
			id: 2,
			image: peter,
			name: 'Peter Parker',
			role: 'Cinematographer',
			no_of_projects: 15,
		},
		{
			id: 3,
			image: man_camera,
			name: 'David Bambam',
			role: 'Movie Director',
			no_of_projects: 1,
		},
		{
			id: 4,
			image: sophia,
			name: 'Sophia Stone',
			role: 'Graphics Effect Artisit',
			no_of_projects: 5,
		},
		{
			id: 5,
			image: noah,
			name: 'Noah Emeka',
			role: 'Photographer',
			no_of_projects: 32,
		},
		{
			id: 6,
			image: bozzy,
			name: 'Bozzy',
			role: 'Movie Director',
			no_of_projects: 0,
		},
	]

	const partners = [netflix, showtime, mnet_movies, fox, disney_small]

	return (
		<>
			<main className='prof_page'>
				<section
					className='prof_page_banner'
					style={{ background: `url(${home_bgs})` }}
				>
					<div className='container'>
						<div className='d-flex prof_page_banner_text'>
							<div>
								<h2>
									Find the perfect movie production crew for your movie set...
								</h2>
								<form action=''>
									<div className='input-group mb-3'>
										<input
											type='email'
											className='form-control'
											placeholder='Search Professionals.......'
										/>
										<button className='btn' type='submit' id=''>
											Search
										</button>
									</div>
								</form>
								<p className='text-white'>
									<strong>Tags:</strong>{' '}
									{tags.map((e) => (
										<span className='tags'> {e} </span>
									))}
								</p>
							</div>
						</div>
					</div>
				</section>

				<section className='prof_page_partners'>
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-12'>
								<div className='row'>
									<div className='col-lg-2 col-md-3 col-4'>
										<p>Trusted Partners:</p>
									</div>
									<div className='col-lg-10 col-md-9 col-8 text-center'>
										<Slider {...partnersSettings}>
											{partners.map((e) => (
												<div className='text-center'>
													<img src={e} alt='' />
												</div>
											))}
										</Slider>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section
					className='prof_page_services'
					style={{ background: `url(${partners_bg})` }}
				>
					<div className='container'>
						<div className='row'>
							<div className='col-md-7'>
								<h3 className='section_header '>
									Popular Professional Services
								</h3>
							</div>

							<div className='col-md-5 '>
								<div className='homepage_projects_padbox_select float-right'>
									<select
										value={selected}
										onChange={(e) => setSelected(e.target.value)}
										className='form-select mb-3'
										style={{ width: '12rem' }}
									>
										<option value=''>All Categories</option>
										{/* <option value=''>All</option> */}
										<option value='photographers'>Photographers</option>
										<option value='writers'>Writers</option>
									</select>
								</div>
							</div>

							<div className='col-md-12 mt-3 pl-5 pr-5'>
								<Slider {...settings}>
									{profss.map((e) => (
										<div className='prof_page_services_box'>
											<img src={e.image} alt='' />
											<div className='d-flex'>
												<p> {e.title} </p>
											</div>
										</div>
									))}
								</Slider>
							</div>
						</div>
					</div>
				</section>

				<section className='prof_page_info'>
					<div className='container'>
						<div className='row'>
							<div className='col-md-7'>
								<iframe
									width='100%'
									height='100%'
									src='https://www.youtube.com/embed/UylDG7HP2HY'
									title='YouTube video player'
									frameborder='0'
									allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
									allowfullscreen
								></iframe>
							</div>
							<div className='col-md-5'>
								<div>
									<h5 className='mb-3'>
										<strong>
											A whole world of professionals at your fingertips
										</strong>
									</h5>

									{tips.map((tip) => (
										<div className='prof_page_info_box'>
											<div className='d-flex'>
												<img src={tip.icon} alt='' />
												<h6>
													<strong> {tip.title} </strong>
												</h6>
											</div>
											<p> {tip.para} </p>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className='pt-5'>
					<div className='container'>
						<div className='row'>
							<div className='col-md-12 text-center mb-2'>
								<h3 className='section_header'>
									Explore our full list of professionals
								</h3>
							</div>
						</div>
						<div className='homepage_projects_padbox'>
							<div className='row'>
								<ProfessionalBox profs={profs} />

								<div className='col-md-12 text-center'>
									<Link to='/professionals/all' className='homepage_btn'>
										View All
									</Link>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className='mt-5 mb-5'>
					<div className='container'>
						<CampaignSlider />
					</div>
				</section>
			</main>
		</>
	)
}

export default Professionals
